import theme, { colors } from '../../config/theme'

export default {
  p: {
    color: colors.text,
    fontFamily: theme.p.fontFamily,
    fontSize: theme.p.fontSize,
    lineHeight: theme.p.lineHeight
  }
}



// WEBPACK FOOTER //
// ./src/components/P/style.js